import { fetchPost } from '../Service/ApiService'

export const bulkSendWithdraw = (selectedIds, resolve, reject) => {
   

    try {
        fetchPost(`withdrawrequest/bulksend`, selectedIds, {
            success: (res) => { resolve(res) },
            fail: (res) => { reject(res) },
            error: (err) => {
                reject({ status: false, message: "Unable to connect server" })
            }
        })
    } catch (e) {
        reject({ status: false, message: "Unable to process operation" })
    }
};


export const bulkRejectWithdraw = (selectedIds, resolve, reject) => {   

    try {
        fetchPost(`withdrawrequest/bulkreject`, selectedIds, {
            success: (res) => { resolve(res) },
            fail: (res) => { reject(res) },
            error: (err) => {
                reject({ status: false, message: "Unable to connect server" })
            }
        })
    } catch (e) {
        reject({ status: false, message: "Unable to process operation" })
    }
};







